export default "<ng-template #childItem></ng-template>\n"